module.exports = __webpack_public_path__ + "static/Board Meeting-b2423383896ba18d6fc9930d663e0165.jpg";